import React, {useState, useEffect} from "react";
import { PageHeader, FormGroup, FormControl, ControlLabel, Button } from "react-bootstrap";
import { View } from "react-native";
import { Checkmark } from "react-checkmark";
import Axios from "axios";
import { addDaysToDate } from "../utils/Common";
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
// import DateFnsUtils from "@date-io/date-fns";
import styled from 'styled-components';
import ReservePageLayout from "../components/ReservePageLayout";
import "./reservations.css";
import { postStripeOrderReservation } from "../utils/bedrockAPI";

const CustomDateTimePicker = styled(DatePicker)`
    & .MuiInputBase-input {
        font-size: 24px;
        border: 1px solid #CCC;
        padding: 5px;
        cursor: pointer;
        text-align: center;
        min-width: 0;
        min-height: 40px;
        border-radius: 6px;
        width: 100%;
    }

    & .MuiInputBase-input:hover {
        background-color: #F5F5F5;
    }
`;

export default function ReadyNowSuccess(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [orderComplete, setOrderComplete] = useState(false);
    const [docId, setDocId] = useState(null);
    const [customerId, setCustomerId] = useState(null);
    const [installerName, setInstallerName] = useState("");
    const [installerEmail, setInstallerEmail] = useState("");
    const [managerName, setManagerName] = useState("");
    const [managerEmail, setManagerEmail] = useState("");

    useEffect(() => {
        if(orderComplete) {
            setTimeout(() => {
                setOrderComplete(false);
                props.history.push('/reserve');
            },5000);
        }
    },[orderComplete]);

    useEffect(() => {
        const tempDocId = JSON.parse(sessionStorage.getItem('documentId'));
        if(tempDocId) setDocId(tempDocId);
        const tempCustomerId = JSON.parse(sessionStorage.getItem('stripeCustomerId'));
        if(tempCustomerId) setCustomerId(tempCustomerId);
    },[]);

    async function handleSubmit(e) {
        e.preventDefault();
        setIsLoading(true);
        const data = {
            documentId: docId,
            customerId: customerId,
            installerName: installerName,
            managerName: managerName,
            installerEmail: installerEmail,
            managerEmail: managerEmail
        };
        try {
            await postStripeOrderReservation(data);
            setOrderComplete(true);
        } catch(error) {
            console.log(error);
            alert("There was an error finalizing your order. Please contact support.");
        }
        setIsLoading(false);
    }

    return (
        <ReservePageLayout handleLogout={props.handleLogout}>
            <View>
                <div className="reservation-page-header">
                    <PageHeader>
                        Additional Contacts
                    </PageHeader>
                </div>
                <div className="reservation-center-row">
                <div className="reservation-width-standard">
                    {orderComplete ? (
                        <div className="reservation-success-container">
                            <div className="reservation-success-checkmark">
                                <Checkmark size='xlarge' color="#131659"/>
                            </div>
                            <br /><br />
                            <b>Thank you for your order!</b>
                            <br /><br />
                            <b>You will receive an email confirmation shortly.</b>
                        </div>
                    ) : (
                        <div>
                            {/* <div style={{fontSize:"16px",fontWeight:600,paddingBottom:"8px"}}>
                                Please select a date you would like your cameras delivered.
                            </div>
                            <div style={didNotSelectDate ? {backgroundColor:"#FEE2E2",border:"1px solid #FCA5A5",borderRadius:6,padding:"8px",marginBottom:"10px"} : {marginBottom:"10px"}}>
                                <div style={{display:"flex", alignItems:"center"}}>
                                    <ControlLabel style={{width:"120px", marginRight:"16px", marginBottom:0}}>Date</ControlLabel>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <div style={{flex:1}}>
                                            <CustomDateTimePicker
                                            format={"MMM d"}
                                            value={deliveryDate}
                                            onChange={setDeliveryDate}
                                            minDate={addDaysToDate(new Date(),4)}
                                            InputProps={{disableUnderline:true}}
                                                style={{width:"100%"}}
                                            />
                                        </div>
                                    </MuiPickersUtilsProvider>
                                </div>
                            </div>
                            {showExtraInfo ? (
                                <div style={{fontSize:"12px",color:"#6B7280"}}>
                                    Note: We often carry a two week lead time on new deliveries, due to order volume. We will follow up with you to confirm the delivery date after submitting the order below.
                                </div>
                            ) : (<div></div>)}
                            <br /> */}
                            <div className="text-subtitle">
                                Who will manage the camera installation (if different from yourself)?
                            </div>
                            <div className="reservation-form-row" style={{paddingBottom:"20px"}}>
                                <FormGroup controlId="installerName" bsSize="large" className="reservation-form-group">
                                    <ControlLabel>Name</ControlLabel>
                                    <FormControl value={installerName} onChange={e => setInstallerName(e.target.value)} />
                                </FormGroup>
                                <div className="reservation-form-row-with-spacing">
                                    <FormGroup controlId="installerEmail" bsSize="large" className="reservation-form-group">
                                        <ControlLabel>Email</ControlLabel>
                                        <FormControl value={installerEmail} onChange={e => setInstallerEmail(e.target.value)} />
                                    </FormGroup>
                                </div>
                            </div>
                            <br />
                            <div className="text-subtitle">
                                Who is the construction manager for the project (if different from above)?
                            </div>
                            <div className="reservation-form-row">
                                <FormGroup controlId="managerName" bsSize="large" className="reservation-form-group">
                                    <ControlLabel>Name</ControlLabel>
                                    <FormControl value={managerName} onChange={e => setManagerName(e.target.value)} />
                                </FormGroup>
                                <div className="reservation-form-row-with-spacing">
                                    <FormGroup controlId="managerEmail" bsSize="large" className="reservation-form-group">
                                        <ControlLabel>Email</ControlLabel>
                                        <FormControl value={managerEmail} onChange={e => setManagerEmail(e.target.value)} />
                                    </FormGroup>
                                </div>
                            </div>
                            {/* {didNotSelectDate ? (
                                <div style={{color:"#B91C1C", fontWeight:600, paddingTop:"28px"}}>
                                    Please select a target date for delivery
                                </div>
                            ) : (<div />)} */}
                            <form onSubmit={handleSubmit}>
                                <View style={{flex:1, flexDirection:"row",justifyContent:"center",paddingTop:"28px"}}>
                                    <Button
                                        block
                                        type="submit"
                                        bsSize="large"
                                        disabled={isLoading}
                                    >
                                        Finalize Your Order
                                    </Button>
                                </View>
                            </form>
                        </div>
                    )}
                </div>
            </div>
            </View>
        </ReservePageLayout>
    );
}



